import apiUrl from '../../../constants';
import axios from 'axios';
import {
	Validator
} from 'vee-validate';
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from './../shared/loader'
import moment from 'moment'

export default {
	name: 'viewticket',
	components: {
		vSelect,
		DatePicker,
		VueElementLoading,
		Loader
	},
	props: ['selectedRow', 'filterData'],
	data: function() {
		return {
			ticketNoQuery:this.selectedRow.number,
			messages: [],
			isLoading: false,
			ticketNo: '',
			clientNameDisplay: '',
			warehouseNameDisplay: '',
			createdDate: '',
			subject: '',
			assignedTo: '',
			topic: '',
			status: '',
			templateDescription: '',
			selectedImageFile: '',
			userEmail: '',
			ticketId: '',
			isLoading1: false,
			s3UploadData: [],
			userName: '',
			detailedDescription: '',
			file: '',
			attachmentUrl: '',
			defaultClass: 'fa fa-picture-o'
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.fullname
		// this.ticketNoQuery = this.$route.query.ticketno
		this.ticketId = this.$route.query.ticketid
		this.userEmail = userdetail.email
		this.getTicketDetails()
		this.user_type = userdetail.utype;

		switch (this.user_type) {
			case 'system_user':
				break;
			case 'client_user':
				break;
			case 'warehouse_user':
				break;
			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		},
		viewDownloadDocument(s3url) {
			if (s3url.sendUrl) {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.isLoading = true;
				this.s3UploadData = [];
				this.input = ({
					's3url': s3url.url,
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'viewDocument',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
							if (result.data.Status) {
								window.open(result.data.url)
							} else {
								this.$alertify.error("Attachments Details Not Found");
							}
							this.isLoading = false
						},
						error => {
							console.error(error)
						})
			}
		},
	
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		onUploadFile() {
			if (document.getElementById('file').value) {
				let formData = new FormData();
				this.selectedImageFile = this.file;
				formData.append('files', this.selectedImageFile);
				formData.append('ticketno', this.ticketNoQuery);
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'fileUploadOsTicket',
						'data': formData,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(result => {
						if (result.data.Status) {
							this.attachmentUrl = result.data.Data.Key
							document.getElementById('file').value = ''
							this.replyTicket()
						} else {
							this.$alertify.error("File Not Uploaded");
						}
						this.isLoading = false;
					})
			} else {
				this.replyTicket()
			}
		},
		dateFormatDetail(date) {
			if (!date) return '';
			return moment(date).format('LLLL');
		},
		getTicketDetails() {
			this.messages = []
			this.templateDescription = ''
			this.$validator.reset()
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading1 = true;
			this.input = ({
				"ticketno": this.ticketNoQuery
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'viewTicket',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (result.data.status) {
							this.createdDate = result.data.data.data.created
							let str = result.data.data.data.subject;
							let string_split = str.split(",") ? str.split(",") : null;
							let subject = string_split[2].split("Subject!!!")[1] ? string_split[2].split("Subject!!!")[1] : null;
							this.subject = subject
							this.assignedTo = result.data.data.data.assigned
							this.topic = result.data.data.data.topic
							this.status = result.data.data.data.current_status
							this.ticketNo = result.data.data.data.number
							let clientName = result.data.data.data.thread[0].textbody
							let warhouseName = result.data.data.data.thread[0].textbody
							let clientName_split = clientName.split(",");
							let warhouseName_split = warhouseName.split(",");
							this.clientNameDisplay = clientName_split[1].split("Client:")[1] ? clientName_split[1].split("Client:")[1] : null
							this.warehouseNameDisplay = warhouseName_split[2].split("Warehouse:")[1] ? warhouseName_split[2].split("Warehouse:")[1] : null
							result.data.data.data.thread.forEach((el) => {
								var str = el.textbody;
								let string_split = str.split(",");
								let attachment_url = string_split[0].split("Attachment!!!")[1] ? string_split[0].split("Attachment!!!")[1] : null;
								let body2 = el.textbody
								if (el.type == 'M') {
									body2 = string_split.slice(1).join(', ');
								}

								if (el.type == 'M' && attachment_url && attachment_url != null && attachment_url != '' && attachment_url != undefined) {
									let fileextension = attachment_url.split('.').pop()

									this.messages.push({
										"author": el.type,
										"body": fileextension.toUpperCase(),
										"body1": body2,
										"date": el.created,
										"msgSender": el.poster,
										"url": attachment_url,
										"sendUrl": true
									})
								} else {
									this.messages.push({
										"author": el.type,
										"body": body2,
										"body1": body2,
										"date": el.created,
										"msgSender": el.poster,
										"url": "",
										"sendUrl": false
									})
								}
							})
						} else {
							this.$alertify.error("Ticket Details Not Found");
						}
						this.isLoading1 = false
					},
					error => {
						console.error(error)
					})
		},
		replyTicketValidate() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log("Invalid Form");
					return false;
				} else {
					console.log("Valid Form");
					this.onUploadFile()
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		getS3Urls() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			this.s3UploadData = [];
			this.input = ({
				'ticketno': this.ticketNoQuery,
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getS3Urls',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (result.data.status) {
							this.s3UploadData = result.data.data
						} else {
							// this.$alertify.error("Attachments Details Not Found");
						}
						this.isLoading = false
					},
					error => {
						console.error(error)
					})
		},
		replyTicket() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			let detailedDescription = "Attachment!!!" + this.attachmentUrl + "Attachment!!!," + "Description:" + this.templateDescription
			this.input = ({
				'number': this.ticketNoQuery,
				'email': this.userEmail,
				'message': detailedDescription
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'replyTicket',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
						if (result.data.status) {
							this.$alertify.success(result.data.data.msg);
							this.getTicketDetails()
						} else {
							this.$alertify.error(result.data.data.msg ? result.data.data.msg : result.data.msg);
						}
						this.isLoading = false
					},
					error => {
						console.error(error)
					})
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/viewticket/viewticket.component.js